<template>
  <div class="group group--sidebar group--df-column pab2">
    <div class="mw600">
      <h1 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h1 group__title mw600 mw700">{{ title }}</h1>
      <div class="group group--wide group--df-column" v-if="!editMode">
        <h3 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="c-accent mb">Personal Information</h3>
        <module-read-only-form
          v-for="(field, key) in personalInfo"
          :key="key"
          :field="field"
        />
        <h3 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="c-accent mb mt2">Contact Information</h3>
        <module-read-only-form
          v-for="(field, key) in contactInfo"
          :key="key"
          :field="field"
        />

        <router-link 
          v-if="org.dfd_client !== true"
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="link link--accent link--arrow tdn fw-bold mt2"
          :to="{ path: `/profile/change-password`}">Change password</router-link>

        <router-link 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="link link--accent link--arrow tdn fw-bold mt"
          :to="{ path: `/log-out`}">Logout</router-link>
      </div>

      <div v-if="editMode">
        <module-change-password v-if="editMode === `change-password`" />
      </div>
    </div>
  </div>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';
// Models
import profileModel from 'models/profile';

// Modules
import ModuleReadOnlyForm from 'components/ReadOnlyForm';
import ModuleChangePassword from 'views/auth/Change';

export default {
  name: 'view-profile',

  // Components
  components: {
    ModuleReadOnlyForm,
    ModuleChangePassword,
  },

  // Data
  data() {
    return {
      userData: null,
      editTitles: {
        'change-password': 'Change your password',
      },
    };
  },

  computed: {
    ...mapGetters('app', ['org']),
    ...mapGetters('auth', [
      'isAuthenticated',
    ]),

    profile() {
      return profileModel;
    },
    personalInfo() {
      return this.getFormFields(['first_name', 'last_name', 'gender']);
    },
    contactInfo() {
      return this.getFormFields(['phone', 'zip', 'email']);
    },

    title() {
      return this.editTitles[this.editMode] || 'Your profile';
    },

    editMode() {
      return this.$route.params.profileSection || false;
    },
  },

  // Methods
  methods: {
    getFormFields(currentFields) {
      const fields = {};
      currentFields.forEach((label) => {
        fields[label] = this.profile.profile.fields[label];
      });
      return fields;
    },
  },

  // Created
  created() {
    if ( !this.isAuthenticated ) {
      this.$router.push({ name: 'home' });
    }

    if ( localStorage.getItem('updateUser') ) {
      this.userData = JSON.parse(localStorage.getItem('updateUser'));

      Object.keys(this.profile.profile.fields).forEach((field) => {
        if(this.userData[field]) {
          this.profile.profile.fields[field].value = this.userData[field];
        }
      });
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (localStorage.getItem('changePasswordSuccess')) {
      to.meta.messages = ['All set. We’ve updated your password.'];
      localStorage.removeItem('changePasswordSuccess');
    }

    if ( !from.params.profileSection ) {
      delete from.meta.messages;
    }

    next();
  },
};
</script>



// WEBPACK FOOTER //
// Profile.vue?7638af5a